import { render, staticRenderFns } from "./cr_abas.vue?vue&type=template&id=96b1d520&"
import script from "./cr_abas.vue?vue&type=script&lang=js&"
export * from "./cr_abas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96b1d520')) {
      api.createRecord('96b1d520', component.options)
    } else {
      api.reload('96b1d520', component.options)
    }
    module.hot.accept("./cr_abas.vue?vue&type=template&id=96b1d520&", function () {
      api.rerender('96b1d520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_abas.vue"
export default component.exports